/** Booking identity format; leading zeros are valid, an all-zero placeholder is not. */
export const getIdCardError = (value: string): string | null => {
  if (!value) return 'יש להזין מספר תעודת זהות';
  if (/^0+$/.test(value)) return 'מספר תעודת זהות לא יכול להכיל אפסים בלבד';
  if (!/^[0-9]{9}$/.test(value)) return 'מספר תעודת זהות חייב להכיל בדיוק 9 ספרות';
  return null;
};

export const isValidIdCard = (value: string): boolean => getIdCardError(value) === null;
